export default function (ctx, inject) {
    // Options
    const nuxtConfigOptions = {}

    inject('moduleOptions', nuxtConfigOptions)
}
